module.exports = __webpack_public_path__ + "img/dialog-top.2595aa70.png";